var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"px-4 pt-4",attrs:{"align":"center"}},[_c('div',{staticClass:"page-header-left px-4 py-6"},[_c('h3',{staticClass:"text-h4 px-3",staticStyle:{"font-family":"'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important"}},[_vm._v(_vm._s(_vm.pageTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }